<template>

    <ui-view v-spinner="loading" :hide="loading">

        <ui-heading :title="pageTitle" icon="magicon-user">
            <ui-button color="positive" :loading="submitting" @click="$refs.form.submit()">Opslaan</ui-button>
        </ui-heading>

        <ui-form-panel auto-validate ref="form" @submit="submit">

            <ui-form-input
                title="Gebruikersnaam"
                name="username"
                :disabled="true"
                rules="required"
                v-model="pendingUser.username"/>

            <ui-form-input
                title="E-mail adres"
                name="email"
                rules="required|email"
                v-model="pendingUser.email"/>

            <ui-form-input
                title="Telefoonnummer"
                name="phoneNumber"
                v-model="pendingUser.phoneNumber"/>

            <ui-form-input
                v-if="itemId"
                title="Nieuw wachtwoord"
                type="password"
                name="password"
                v-model="pendingUser.password"/>

            <ui-form-input
                v-if="(pendingUser.password && pendingUser.password.length) || !itemId"
                title="Wachtwoord herhalen"
                type="password"
                name="passwordConfirm"
                rules="required|confirmed:password"
                v-model.trim="passwordConfirm"/>

        </ui-form-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import { clone, pick } from 'es-toolkit';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import FindUserQuery from 'gql/queries/Account/FindUser.gql';

import UserMutations from 'app/mutations/UserMutations';

@Component({

    name: 'AccountForm',
    apollo: {

        user: createQuery(FindUserQuery, {

            response(response){

                this.pendingUser = {
                    ...pick(response, Object.keys(this.pendingUser)),
                    password: null
                };
            },

            variables(){

                return {
                    userId: this.$user.id
                };
            }
        })
    }
})
export default class AccountForm extends Vue
{
    pendingUser = {
        username: null,
        email: null,
        phoneNumber: null,
        password: null
    };

    passwordConfirm = null;

    loading = 0;
    submitting = false;

    breadcrumb(){

        return [{
            title: 'Account',
            route: {
                name: 'account'
            }
        }, this.pageTitle];
    }

    async submit(){

        this.submitting = true;
        const input = clone(this.pendingUser);

        try {

            if (this.user) {

                input.id = this.user.id;
                if (!input.password) {
                    delete input.password;
                }

                await UserMutations.update(input);

                this.logger.info('User updated');
                this.$toast.success('De gebruiker is opgeslagen');
            }
        }
        catch(e){

            this.logger.error('Error updating/creating user', e);
            this.$toast.error('De gebruiker kon niet worden opgeslagen');
        }

        this.submitting = false;
    }

    get pageTitle(){

        return this.$safe('user.email');
    }

    get itemId(){

        return this.$user.id;
    }
}

</script>